import ActionBar from './ActionBar'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import List from './List'
import {pageRequest} from 'actions/ingredients/recipes'
import {connect} from 'react-redux'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {browserHistory} from 'react-router'
import {isDirty} from 'redux-form'
import {askConfirmAction} from 'actions/confirm-action'
import {push} from 'react-router-redux'
import NoDataAndLoading from 'components/NoDataAndLoading'
import RecipesDetail from './RecipesDetail'
import SaveToAllOutletsModal from './SaveToAllOutletsModal'
import './Recipes.css'

class Recipes extends React.Component {
  render () {
    const {openRightColumn, showLoadingSpinnerPage, recipes} = this.props
    return (<PageWrapper>
      <ActionBar />
      <ContentWrapper>
        <LeftColumnWrapper openRightColumn={openRightColumn}>
          <NoDataAndLoading
            showLoadingSpinner={showLoadingSpinnerPage}
            noDataToDisplay={recipes.length === 0}
            title='No Data To Display'
            description=''
            linkLabel='Create Recipe'
            linkUrl='https://mokaposhelp.zendesk.com/hc/en-us/articles/115004499493-Create-Recipe'
          />
          {!showLoadingSpinnerPage && <List />}
        </LeftColumnWrapper>
        <RightColumnWrapper openRightColumn={openRightColumn}>
          <RecipesDetail />
        </RightColumnWrapper>
      </ContentWrapper>
      <ConfirmActionModal />
      <SaveToAllOutletsModal />
    </PageWrapper>)
  }

  componentDidMount () {
    const {dispatch, expired} = this.props
    if (!expired) {
      dispatch(pageRequest())
      browserHistory.listenBefore((location) => {
        const {isDirtyRecipes, nextAction} = this.props
        if (isDirtyRecipes && !nextAction) {
          dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }
}

function mapStateToProps (state) {
  const {showLoadingSpinnerPage} = state.loadingSpinner
  const {expired} = state.subscriptionExpired
  const {openRightColumn, recipes} = state.ingredients.recipes
  return {
    openRightColumn,
    showLoadingSpinnerPage,
    nextAction: state.confirmAction.nextAction,
    isDirtyRecipes: isDirty('recipes')(state),
    expired,
    recipes
  }
}

export default connect(mapStateToProps)(Recipes)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Recipes/Recipes.js